import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const weeks = [{
    week: 1,
    title: 'Semana 1-2',
    desc: 'Caminata + trote suave (intervalos cortos)'
  }, {
    week: 3,
    title: 'Semana 3-4',
    desc: 'Aumentamos tiempo de trote gradualmente'
  }, {
    week: 5,
    title: 'Semana 5-6',
    desc: 'Más trote, menos caminata'
  }, {
    week: 7,
    title: 'Semana 7-8',
    desc: 'Corres 5K completos sin parar'
  }];
  return <section ref={ref} className="py-20 px-4 bg-navy" data-id="element-129">
      <div className="max-w-6xl mx-auto" data-id="element-130">
        <motion.h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 text-center leading-tight" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-131">
          Un método diseñado para{' '}
          <span className="text-accent" data-id="element-132">personas que siempre abandonan</span>
        </motion.h2>

        <motion.p className="text-xl md:text-2xl text-gray-300 text-center mb-16 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-133">
          Un sistema{' '}
          <span className="text-white font-semibold" data-id="element-134">paso a paso</span>,{' '}
          <span className="text-white font-semibold" data-id="element-135">progresivo</span> y
          diseñado para que{' '}
          <span className="text-accent font-bold" data-id="element-136">NO necesites motivación</span>{' '}
          para seguir adelante.
        </motion.p>

        {/* Timeline */}
        <div className="relative" data-id="element-137">
          {/* Vertical line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-1 bg-accent/30 transform md:-translate-x-1/2" data-id="element-138" />

          <div className="space-y-12" data-id="element-139">
            {weeks.map((item, i) => <motion.div key={i} className="relative flex items-center gap-8" initial={{
            opacity: 0,
            x: i % 2 === 0 ? -50 : 50
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3 + i * 0.1
          }} data-id="element-140">
                {/* Timeline dot */}
                <div className="absolute left-8 md:left-1/2 w-4 h-4 bg-accent rounded-full transform md:-translate-x-1/2 ring-4 ring-navy z-10" data-id="element-141" />

                {/* Content */}
                <div className={`flex-1 ml-20 md:ml-0 ${i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:pl-12 md:ml-auto'} md:w-1/2`} data-id="element-142">
                  <div className="bg-navy-light p-6 rounded-xl border border-accent/20" data-id="element-143">
                    <div className="flex items-center gap-2 mb-2" data-id="element-144">
                      <CheckCircle2 className="text-accent" size={24} data-id="element-145" />
                      <h3 className="text-2xl font-bold text-accent" data-id="element-146">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-gray-300 text-lg" data-id="element-147">{item.desc}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}